var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _rect2, _circle, _rect3, _circle2, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _polygon, _path30, _path31, _polygon2, _path32, _path33;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConstitution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eb7145bf-7e09-429c-a529-19108004bd12",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 905.39,
    height: 787.66,
    viewBox: "0 0 905.39 787.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "badc8065-97f0-494e-a3b4-5bbff5cd45b7",
    x1: 637.69,
    y1: 801.36,
    x2: 637.69,
    y2: 253.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "338acb06-6351-441a-9d26-fc18c3a8e8ec",
    x1: 407.08,
    y1: 313.45,
    x2: 407.08,
    y2: 243.56,
    xlinkHref: "#badc8065-97f0-494e-a3b4-5bbff5cd45b7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "49c489d3-2f08-4073-8a57-307e6f5f09e6",
    x1: 406.79,
    y1: 366.25,
    x2: 406.79,
    y2: 318.23,
    xlinkHref: "#badc8065-97f0-494e-a3b4-5bbff5cd45b7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7e7ecb7f-7627-4435-aa53-ec925b4c6a6e",
    x1: 410.39,
    y1: 417.44,
    x2: 410.39,
    y2: 371.18,
    xlinkHref: "#badc8065-97f0-494e-a3b4-5bbff5cd45b7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "16dcb405-8b1a-43fc-a0eb-646bd32fadb0",
    x1: 409.82,
    y1: 497.91,
    x2: 409.82,
    y2: 438.02,
    xlinkHref: "#badc8065-97f0-494e-a3b4-5bbff5cd45b7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af7c329d-2d92-47dc-bbd0-cd12fc34dcf2",
    x1: 520.63,
    y1: 525.14,
    x2: 520.63,
    y2: 109.57,
    xlinkHref: "#badc8065-97f0-494e-a3b4-5bbff5cd45b7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4cbf4c01-8989-429b-a5cb-fb3822288f3e",
    x1: 518.01,
    y1: 297.89,
    x2: 518.01,
    y2: 251.22,
    xlinkHref: "#badc8065-97f0-494e-a3b4-5bbff5cd45b7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b57b7fc7-667a-4a47-b04d-9b0384954319",
    x1: 518.01,
    y1: 358.71,
    x2: 518.01,
    y2: 312.04,
    xlinkHref: "#badc8065-97f0-494e-a3b4-5bbff5cd45b7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b86df79f-4b6f-4b4a-a220-4e26d2bf8be6",
    x1: 477.01,
    y1: 286.35,
    x2: 477.01,
    y2: 254.5,
    xlinkHref: "#badc8065-97f0-494e-a3b4-5bbff5cd45b7"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "accept_terms") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.71,460.46c2.74,30.35,19.91,57.83,30.41,86.74a205.61,205.61,0,0,1,4,127.67c-2.5,8.61-5.58,17.25-5.59,26.07,0,30.41,34.65,50.59,66.13,64a1205.37,1205.37,0,0,0,248.89,75.2c27.94,5.27,62.83,7.56,80.51-12.29,8.48-9.53,10.54-22,16.77-32.66,15.89-27.26,54.55-37.85,89.25-43.92a1090.22,1090.22,0,0,1,126.48-14.56c42.69-2.4,91.17-4.48,119.46-32.52,18-17.82,23.22-42.41,23.93-65.63,2.35-76.19-34.06-158.64,12.67-224.63,19.6-27.68,51.58-47.89,71-75.64,28.15-40.22,25.72-91.3,6.66-134.16s-52.83-79.3-86.1-115c-11-11.81-22.74-24.09-39.28-29.57-17.2-5.7-36.7-3.08-55.14-.39-83.88,12.25-171,25.59-241.31,67.65-34.94,20.89-64.12,48-95.29,72.89-67.33,53.83-145.34,103.56-234.25,124.81C214.68,341.8,141.21,388.38,147.71,460.46Z",
    transform: "translate(-147.3 -56.17)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M422.22,244.42s-58-10.24,0,68.28Z",
    transform: "translate(-147.3 -56.17)",
    fill: "#ffbec7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M820.42,642s-8.4-9.54-31.59-3.79c-11.35-10.82-25.49-26.5-26-37.87-4.72,1.55-9.33,3.3-13.86,5.22-19.64-21.94-44.81-56.76-43.74-90.28C707,460.58,669.44,366,669.44,366s3.1-38.57-2.71-70.45c-3.94-21.6-12-40.12-27.83-41.53a17.31,17.31,0,0,0-7.25.79c-29.25,10-11.08,103.37-11.08,103.37l-25.31,78.12-148.37,79s89.89,118.05,133.53,122.39c0,0,32.15,33.72,55.31,63.32-8.18,11-12.55,18.28-12.55,18.28l22.42,31.92c-9.21,12.37-22.17,36.57,6.38,47.93,39.27,15.62,125.67-55.55,125.67-55.55S852.71,694.09,820.42,642Z",
    transform: "translate(-147.3 -56.17)",
    fill: "url(#badc8065-97f0-494e-a3b4-5bbff5cd45b7)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M420.27,244s-59.35-10.42,0,69.44Z",
    transform: "translate(-147.3 -56.17)",
    fill: "url(#338acb06-6351-441a-9d26-fc18c3a8e8ec)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M406.74,318.23s-21.7,0-21.22,26.82a21.59,21.59,0,0,0,14.78,20.27,18.47,18.47,0,0,0,14-1,24.4,24.4,0,0,0,7.26-38.52A24.87,24.87,0,0,0,406.74,318.23Z",
    transform: "translate(-147.3 -56.17)",
    fill: "url(#49c489d3-2f08-4073-8a57-307e6f5f09e6)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M417.24,372.67a14.31,14.31,0,0,0-6.14-1.49s-20.95,5.21-17.45,30.38c0,0,1.75,18.23,20.07,15.62,12.56-1.79,14.05-18.26,13.75-28.44A18.33,18.33,0,0,0,417.24,372.67Z",
    transform: "translate(-147.3 -56.17)",
    fill: "url(#7e7ecb7f-7627-4435-aa53-ec925b4c6a6e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M418.12,439.51a11.64,11.64,0,0,0-5.26-1.49,55.15,55.15,0,0,0-6.46,4.78,51.47,51.47,0,0,0-9,9.77c-7.9,11.44-10.47,28.25,19,45.35V475.34a46,46,0,0,0,9.12-11.77A17.85,17.85,0,0,0,418.12,439.51Z",
    transform: "translate(-147.3 -56.17)",
    fill: "url(#16dcb405-8b1a-43fc-a0eb-646bd32fadb0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M620.65,711.69s53.77-89.61,136.55-116.92l-4.27,48.65-68.6,68.28Z",
    transform: "translate(-147.3 -56.17)",
    fill: "#dfe5ee"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M620.65,711.69s53.77-89.61,136.55-116.92l-4.27,48.65-68.6,68.28Z",
    transform: "translate(-147.3 -56.17)",
    opacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M648.81,735.59s-38.41,39.26,0,54.62,122.9-54.62,122.9-54.62,73.4-48.65,41.82-99.86C813.53,635.73,777.69,594.76,648.81,735.59Z",
    transform: "translate(-147.3 -56.17)",
    fill: "#6c63ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M765.74,622.07S653.93,751.8,655.64,733c.5-5.46-5.8-16.34-15-29-22.35-30.91-61.82-72.53-61.82-72.53-42.67-4.27-130.58-120.34-130.58-120.34l145.09-77.67,24.75-76.81S600.32,264.83,628.92,255a16.84,16.84,0,0,1,7.09-.78,19.19,19.19,0,0,1,3.11.53c13.39,3.37,20.45,20.34,24,40,0,.11.05.23.07.34,5.68,31.35,2.65,69.27,2.65,69.27s36.7,93,35,146.8c-1.14,36,28.31,73.52,47.91,94.39C758.47,615.83,765.74,622.07,765.74,622.07Z",
    transform: "translate(-147.3 -56.17)",
    fill: "#ffbec7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M611.26,552.94s1.71-81.08-12.8-101.56S467,516.25,467,516.25,588.22,530.75,611.26,552.94Z",
    transform: "translate(-147.3 -56.17)",
    opacity: 0.05
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M648.81,582s52.7-31.16,52-81.3",
    transform: "translate(-147.3 -56.17)",
    opacity: 0.05
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M620.65,611.83s-14.51,20.48-41.82,19.63",
    transform: "translate(-147.3 -56.17)",
    opacity: 0.05
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M765.74,622.07S653.93,751.8,655.64,733c.5-5.46-5.8-16.34-15-29,61.93-21.24,95.55-74.23,108.13-98.47C758.47,615.83,765.74,622.07,765.74,622.07Z",
    transform: "translate(-147.3 -56.17)",
    opacity: 0.05
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M796.1,645.72a3.66,3.66,0,0,1-.08.74c-1.72,8.64-3,17.35-4.41,26.06a50.27,50.27,0,0,1-2,8.15,64.7,64.7,0,0,1-10.83,19.49c-34,43.08-120.58,65.29-120.58,65.29l-.32-.47-37.23-53.3C718.8,692.91,757.2,594.76,757.2,594.76c.74,16.39,30.09,41.87,37.55,48.09a3.77,3.77,0,0,1,1.34,2.87Z",
    transform: "translate(-147.3 -56.17)",
    fill: "#dfe5ee"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M663.16,294.72c-24.78-3.17-26.79-24.37-24.85-39.71.26-.09.54-.18.81-.25C652.51,258.13,659.57,275.1,663.16,294.72Z",
    transform: "translate(-147.3 -56.17)",
    fill: "#eff4f8",
    opacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M796.1,645.72a3.66,3.66,0,0,1-.08.74c-1.72,8.64-3,17.35-4.41,26.06a50.27,50.27,0,0,1-2,8.15l-2.11,5.84L782.38,695l-3.6,5.12c-34,43.08-120.58,65.29-120.58,65.29l-.32-.47c2.71-1.12,61.06-25.23,84.39-46.9,22.14-20.55,49.4-67.47,53.3-74.28A3.77,3.77,0,0,1,796.1,645.72Z",
    transform: "translate(-147.3 -56.17)",
    opacity: 0.05
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M784,690.85",
    transform: "translate(-147.3 -56.17)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M607.67,109.57H433.59a17.22,17.22,0,0,0-17.25,17.19v381.2a17.22,17.22,0,0,0,17.25,17.19H607.67a17.22,17.22,0,0,0,17.25-17.19V126.75A17.22,17.22,0,0,0,607.67,109.57Z",
    transform: "translate(-147.3 -56.17)",
    fill: "url(#af7c329d-2d92-47dc-bbd0-cd12fc34dcf2)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 270.63,
    y: 56.58,
    width: 205.39,
    height: 410.79,
    rx: 11,
    ry: 11,
    fill: "#535461"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 285.76,
    y: 94.8,
    width: 175.14,
    height: 334.36,
    fill: "#f1f1f4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 352.63,
    cy: 75.69,
    r: 1.59,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 360.59,
    y: 74.1,
    width: 35.03,
    height: 3.18,
    rx: 1,
    ry: 1,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 372.53,
    cy: 445.08,
    r: 11.15,
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M409,317.39s-21.23,0-20.75,26.37a21.22,21.22,0,0,0,14.45,19.93,18,18,0,0,0,13.67-1A24,24,0,0,0,409,317.39Z",
    transform: "translate(-147.3 -56.17)",
    fill: "#ffbec7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M409,331s-19.63,13.66-2.56,25.6C406.43,356.65,404.72,332.75,409,331Z",
    transform: "translate(-147.3 -56.17)",
    fill: "#eff4f8",
    opacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M413.26,369.45s-20.48,5.12-17.07,29.87c0,0,1.71,17.92,19.63,15.36,12.29-1.76,13.74-18,13.45-28a18,18,0,0,0-10-15.8A13.93,13.93,0,0,0,413.26,369.45Z",
    transform: "translate(-147.3 -56.17)",
    fill: "#ffbec7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M412.4,380.54s-19.63,7.68,0,29C412.4,409.56,403,389.08,412.4,380.54Z",
    transform: "translate(-147.3 -56.17)",
    fill: "#eff4f8",
    opacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M418.38,471.87v22.19c-28.8-16.8-26.29-33.34-18.56-44.58a50.5,50.5,0,0,1,8.83-9.6,53.94,53.94,0,0,1,6.32-4.7,11.34,11.34,0,0,1,5.15,1.47,17.6,17.6,0,0,1,7.18,23.66A45.23,45.23,0,0,1,418.38,471.87Z",
    transform: "translate(-147.3 -56.17)",
    fill: "#ffbec7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M403.87,460.77s-2.22-5.34-4.05-11.3a50.5,50.5,0,0,1,8.83-9.6C414.28,449.13,403.87,460.77,403.87,460.77Z",
    transform: "translate(-147.3 -56.17)",
    fill: "#eff4f8",
    opacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M662.9,364.76s-22.19,24.75-29,27.31",
    transform: "translate(-147.3 -56.17)",
    opacity: 0.05
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M577.51,266.39h-84v.91a23.33,23.33,0,1,0,0,14.52v.91h84l10.5-8.12Zm-106.17,27a18.82,18.82,0,1,1,18.82-18.82A18.81,18.81,0,0,1,471.34,293.37Z",
    transform: "translate(-147.3 -56.17)",
    fill: "url(#4cbf4c01-8989-429b-a5cb-fb3822288f3e)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M472.1,251.6a23,23,0,1,0,23,23A23,23,0,0,0,472.1,251.6Zm0,4.44a18.51,18.51,0,1,1-18.51,18.51A18.5,18.5,0,0,1,472.1,256",
    transform: "translate(-147.3 -56.17)",
    fill: "#00dd90"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "429.23 226.42 346.6 226.42 346.6 210.35 429.23 210.35 439.55 218.43 429.23 226.42",
    fill: "#00dd90"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M577.51,327.21h-84v.91a23.33,23.33,0,1,0,0,14.52v.91h84l10.5-8.12Zm-106.17,27a18.82,18.82,0,1,1,18.82-18.82A18.81,18.81,0,0,1,471.34,354.19Z",
    transform: "translate(-147.3 -56.17)",
    fill: "url(#b57b7fc7-667a-4a47-b04d-9b0384954319)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M472.1,312.42a23,23,0,1,0,23,23A23,23,0,0,0,472.1,312.42Zm0,4.44a18.51,18.51,0,1,1-18.51,18.51,18.5,18.5,0,0,1,18.51-18.51",
    transform: "translate(-147.3 -56.17)",
    fill: "#ff5288"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "429.23 287.24 346.6 287.24 346.6 271.17 429.23 271.17 439.55 279.25 429.23 287.24",
    fill: "#ff5288"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M497.5,258.34,494.2,255a1.75,1.75,0,0,0-2.48,0L471.06,275.5l-8.74-8.81a1.75,1.75,0,0,0-2.48,0L456.53,270a1.75,1.75,0,0,0,0,2.48l13.27,13.38a1.75,1.75,0,0,0,2.48,0l25.22-25a1.75,1.75,0,0,0,0-2.48Z",
    transform: "translate(-147.3 -56.17)",
    fill: "url(#b86df79f-4b6f-4b4a-a220-4e26d2bf8be6)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M496.52,257.92l-3.14-3.16a1.67,1.67,0,0,0-2.36,0l-19.68,19.52L463,265.87a1.67,1.67,0,0,0-2.36,0L457.5,269a1.67,1.67,0,0,0,0,2.36l12.64,12.74a1.67,1.67,0,0,0,2.36,0l24-23.83a1.67,1.67,0,0,0,0-2.36Z",
    transform: "translate(-147.3 -56.17)",
    fill: "#00dd90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstitution);
export default __webpack_public_path__ + "static/media/constitution.a9a4f8f5e5986087d69a255ad72be417.svg";
export { ForwardRef as ReactComponent };